import React from 'react';
import TpClientPaymentDetailsInfoTab from './TpClientPaymentDetailsInfoTab';
import GeneralEntryLogFigma from '../../../Elements/GeneralEntryLog/GeneralEntryLogFigma';
import CommentsEntryLogDescription from '../../../Elements/CommentsEntryLogDescription';
import TabbedPage from '../../../Elements/TabbedPage';
import TpClientPaymentDetailsRefundTab from './TpClientPaymentDetailsRefundTab';
import InvoiceParentAdmin from './InvoiceParentAdmin';

export default class TpClientPaymentDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {};
  }

  urlParams = new URLSearchParams(window.location.search);
  tpClientPaymentId = this.urlParams.get('id');

  static getMenuText() {
    const id = new URLSearchParams(window.location.search).get('id');
    return `Client Payment ${id ? '- ' + id : 'Details'}`;
  }

  tabs = [
    {
      label: 'Information',
      id: 'info',
      icon: 'fa-solid fa-info',
      component: <TpClientPaymentDetailsInfoTab tpClientPaymentId={this.tpClientPaymentId} />,
    },
    {
      label: 'Client Invoices',
      id: 'clientinvoices',
      icon: 'fa-solid fa-file-invoice-dollar',
      component: <InvoiceParentAdmin tpClientPaymentId={this.tpClientPaymentId} />,
    },
    {
      label: 'Refunds',
      id: 'refunds',
      icon: 'fa-solid fa-dollar-sign',
      component: <TpClientPaymentDetailsRefundTab tpClientPaymentId={this.tpClientPaymentId} />,
    },
    {
      label: 'Comments',
      id: 'comments',
      icon: 'fa-solid fa-comment',
      component: (
        <GeneralEntryLogFigma
          description={CommentsEntryLogDescription}
          context={{ entityTypeId: 10033, entityId: this.tpClientPaymentId }}
        />
      ),
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <TabbedPage tabs={this.tabs} />
      </div>
    );
  }
}
